import { render, staticRenderFns } from "./BaseConfirmDialog.vue?vue&type=template&id=4f34f3be"
import script from "./BaseConfirmDialog.vue?vue&type=script&lang=js"
export * from "./BaseConfirmDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports